import { render, staticRenderFns } from "./InstallationDetail_Template.vue?vue&type=template&id=01c87df2&scoped=true&"
import script from "./InstallationDetail_Template.vue?vue&type=script&lang=js&"
export * from "./InstallationDetail_Template.vue?vue&type=script&lang=js&"
import style0 from "./InstallationDetail_Template.vue?vue&type=style&index=0&id=01c87df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c87df2",
  null
  
)

export default component.exports